import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuList from '@mui/material/MenuList';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { claimViewRoute } from '../constants';

interface Props {
	claimId: string;
}

export const ClaimsMoreActions: React.FC<Props> = ({ claimId }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const navigate = useNavigate();

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<IconButton
				aria-label="more"
				id="actions-button"
				aria-controls={open ? 'menu' : undefined}
				aria-expanded={open ? 'true' : undefined}
				aria-haspopup="true"
				onClick={handleClick}
			>
				<MoreHorizIcon />
			</IconButton>
			<Menu
				id="menu"
				MenuListProps={{
					'aria-labelledby': 'actions-button',
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<MenuList>
					<MenuItem onClick={() => navigate(`${claimViewRoute}/${claimId}`)}>
						<ListItemIcon>
							<EditIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>
							<FormattedMessage id="partner.claims.view.tab.more.actions.view" />
						</ListItemText>
					</MenuItem>
				</MenuList>
			</Menu>
		</>
	);
};
